export const CHANGE_LIVE_INFO = 'liveinfo/CHANGE_LIVE_INFO';
export const GET_MEMBERLIST = 'liveinfo/GET_MEMBERLIST';
export const ADD_MEMBERLIST = 'liveinfo/ADD_MEMBERLIST';
export const REMOVE_MEMBERLIST = 'liveinfo/REMOVE_MEMBERLIST'; 
export const CHANGE_CHAT_LISTS = 'liveinfo/CHANGE_CHAT_LISTS'; 








